import React from 'react';
import { useIntl } from 'react-intl';
import PropTypes from 'prop-types';

import { FormControlLabel, Radio, Typography, makeStyles } from '@material-ui/core';
import { FormRadioGroup } from '../../../../components';

import { getI18n } from "../../../../utils/intl";
import CustomTextInput from '../CustomTextInput';

import styles from './styles';

const LastDateRangeFilter = (props) => {
  const { data, dateRange, handleDateRangeChange,
    customDays, handleEnterKey, typeError, rangeError } = props;

  const intl = getI18n(useIntl());
  const useStyles = makeStyles(styles);
  const classes = useStyles();

  const onSelectOption = (value) => {
    handleDateRangeChange(value, customDays);
  };

  const handleInputChange = (days) => {
    handleDateRangeChange('LAST_DAYS', days);
  };

  const renderOption = (option) => {
    const renderLabel = () => {
      if (option.value === 'LAST_DAYS') {
        return (<CustomTextInput
          days={customDays}
          disabled={dateRange !== 'LAST_DAYS'}
          handleEnterKey={handleEnterKey}
          handleInputChange={handleInputChange}
          rangeError={rangeError}
          typeError={typeError}
        />);
      }
      return (<Typography className={classes.radioLabel}>
        {option.name}
      </Typography>);
    };
    return (<FormControlLabel
      control={
        <Radio />
      }
      key={option.value}
      label={renderLabel()}
      value={option.value}
    />);
  };

  return (
    <div className={classes.root}>
      <span className={classes.dataRangeLabel}>
        {intl.getI18nMessage('label.analyticsDashboard.filter.dateRange.last.label')}
      </span>
      <div className={classes.radioGroup}>
        <FormRadioGroup
          className={classes.choice}
          onChange={onSelectOption}
          radioGroupClasses={{
            root: classes.radioGroupRoot,
          }}
          renderOption={renderOption}
          selected={dateRange}
          name=""
          data={data}
        />
      </div>
    </div>
  );
};

LastDateRangeFilter.propTypes = {
  customDays: PropTypes.string,
  data: PropTypes.array,
  dateRange: PropTypes.string,
  handleDateRangeChange: PropTypes.func,
  handleEnterKey: PropTypes.func,
  rangeError: PropTypes.bool,
  typeError: PropTypes.bool,
};

export default LastDateRangeFilter;
